import { LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { SlhCoreContentContainer } from "@slhuicore/content-container";
import { ClassInfo } from "lit/directives/class-map.js";
import { style } from "./assets/content-container.generated-style";
import { ContentContainerPaddingSize } from "./content-container.type";

/**
 * The concept of paper and elevation (shadows).
 * @CustomElement slh-content-container
 *
 * @cssprop --slh-color-neutral-shade-20 - Field container border color.
 *
 * ** slots
 * @slot default - Container content
 */
@customElement("slh-content-container")
export default class SlhContentContainer extends SlhCoreContentContainer(
  LitElement
) {
  static styles = style;

  /**
   * Padding size
   */
  @property({
    type: ContentContainerPaddingSize,
    attribute: true,
    reflect: true,
  })
  padding: any = ContentContainerPaddingSize.MD;

  /**
   * Changes the padding size on sm+ breakpoints.
   */
  @property({
    type: ContentContainerPaddingSize,
    attribute: "padding-sm",
    reflect: true,
  })
  paddingSm: ContentContainerPaddingSize = ContentContainerPaddingSize.MD;

  /**
   * Changes the padding size on md+ breakpoints.
   */
  @property({
    type: ContentContainerPaddingSize,
    attribute: "padding-md",
    reflect: true,
  })
  paddingMd: ContentContainerPaddingSize = ContentContainerPaddingSize.MD;

  /**
   * Changes the padding size on lg+ breakpoints.
   */
  @property({
    type: ContentContainerPaddingSize,
    attribute: "padding-lg",
    reflect: true,
  })
  paddingLg: ContentContainerPaddingSize = ContentContainerPaddingSize.MD;

  /**
   * Changes the padding size on xl+ breakpoints.
   */
  @property({
    type: ContentContainerPaddingSize,
    attribute: "padding-xl",
    reflect: true,
  })
  paddingXl: ContentContainerPaddingSize = ContentContainerPaddingSize.MD;

  /**
   * Changes the padding size on xxl breakpoint.
   */
  @property({
    type: ContentContainerPaddingSize,
    attribute: "padding-xxl",
    reflect: true,
  })
  paddingXxl: ContentContainerPaddingSize = ContentContainerPaddingSize.MD;

  /**
   * @returns {ClassInfo} ClassList
   */
  renderClasses(): ClassInfo {
    return {
      shadow: this.shadow,
      elevated1: this.elevated1,
      elevated2: this.elevated2,
      field: this.field,
    };
  }
}
